export default {
  SINGLE_VIDEO: 'SINGLE_VIDEO',
  WITH_TAG: 'WITH_TAG',
} as const
